import * as React from 'react'
import * as styles from './FormError.css'

interface IProps {
  children?: any
}

export class FormError extends React.PureComponent<IProps, {}> {
  public render() {
    return <p className={styles.error}>{this.props.children}</p>
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/components/FormError/FormError.tsx